/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  updateCategory,
  handleUpdateCategorie,
  updateRadioButton,
  checkMinValue
} from './CategoryModal.service';
import * as actions from '../../actions/index';
import Input from '../Input';
import Modal from '../Modal';
import { styles } from './CategoryModal.styles';
import Checkbox from '../Checkbox';
import { checkAccess } from '../../utils/admins';
import ShopModal from '../ShopModal';
import Select from '../Select';
import { handleSynchronisationToggle, getShopsToSynchronise } from '../../utils/shopUtils';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import { POS_TYPES, ALL_POS_TYPES, SPLASH, ADDITIONAL, BIBORNE, BIBORNE_POS_TYPES, PRODUCT } from '../../constants'
class CategoryModal extends Component {
  state = {
    items: {},
    item: '',
    category: this.props.category,
    numbOrga: 0,
    isLoading: false,
    synchronize: false,
    showOptionModal: false,
    showModal: false
  };

  componentDidMount() {
    const { items, category } = this.props;
    const updatedCategory = {
      ...category,
      min: category?.min || 0,
      max: category?.max || null
    };

    this.setState({
      items: _.map(items, item => ({ ...item })),
      category: updatedCategory,
    });
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.category, this.props.category) || prevProps.shopId !== this.props.shopId) {
      const { items, category, shopId, createCategorie } = this.props;
      const updatedCategory = {
        ...category,
        min: category?.min || 0,
        max: category?.max || null
      };

      if (createCategorie && hasExternalIntegration(shopId) === SPLASH) {
        updatedCategory.type = PRODUCT;
      }

      this.setState({
        items: _.map(items, item => ({ ...item })),
        category: updatedCategory,
      });
    }
  }
  renderShops = (classes, shopId, isBiborne) => {
    const { showModal, selectedShops = {}, isLoading } = this.state;
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoading}
        onClick={() => handleUpdateCategorie(this, selectedShops, isBiborne)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={'Sélectionnez les magasins dont vous voulez synchroniser ce produit:'}
        title={'Synchroniser votre produit:'}
      />
    );
  };

  render() {
    const { classes, category: initialCategory = {}, shopId, shops } = this.props;
    const { category, synchronize, isLoading, showModal, selectedShops } = this.state;
    const { multiple = false, additional } = category;
    const hasIntegration = hasExternalIntegration(shopId);
    const hasMenuPOS = checkIntegrationAccess('products', 'hasMenuPOS')
    const { name, min = 0, max, type, optionFree = null } = category;
    const isBiborne = hasIntegration === BIBORNE
    const minRequired = isBiborne ? 0 : 1;
    const canUseOptionFree = !max || max > minRequired;
    const hasOptionFree =
      checkIntegrationAccess('option', 'hasOptionFree') && canUseOptionFree;
    const rangeEnd = max
      ? isBiborne
        ? max + 1
        : max
      : 20;
    return (
      <Modal
        color='secondary'
        btnTxt='Enregistrer'
        title={
          this.props.createCategorie
            ? 'Créer une nouvelle liste d\'options'
            : `Modifier ${initialCategory.name || ''}`
        }
        loading={!synchronize && isLoading}
        header
        fixed
        showCancelBtn
        onClick={() => {
          synchronize ?
            this.setState({
              selectedShops: { [shopId]: shops[shopId] },
              showModal: true,
            }) :
            handleUpdateCategorie(this, selectedShops, isBiborne);
        }}

        isOpen={this.props.isOpen}
        handleClose={() => this.props.closeModal()}
      >
        <div>
          <Input
            margin='dense'
            id='name'
            label={`Nom de la liste d'options`}
            classes={{
              label: classes.label
            }}
            type='text'
            value={name}
            onChange={e => updateCategory(e, this)}
            autoFocus
            fullWidth
          />
          <p className='pb-1'></p>
          {hasMenuPOS &&
            <Select
              as='select'
              custom
              label="Type"
              id='type'
              onChange={e => updateCategory(e, this)}
              value={additional ? ADDITIONAL : type}
              required
              name='type'
              disabled={!this.props.createCategorie || hasIntegration === SPLASH}
              className={hasIntegration !== BIBORNE && classes.select}
            >
              <option value=''>
                Choisir
              </option>
              {POS_TYPES[hasIntegration]?.split(',').map(value => (
                <option key={value} value={value}>
                  {hasIntegration === BIBORNE ? BIBORNE_POS_TYPES[value] : ALL_POS_TYPES[value]}
                </option>
              ))}
            </Select>
          }
          <p className='pb-2'>Limites de sélection</p>
          <div>
            <Select
              as='select'
              custom
              className={classes.select}
              label="Minimum"
              id='min'
              onChange={e => updateCategory(e, this)}
              onBlur={e => updateCategory(e, this)}
              value={min}
              required
              name='minimum'
              disabled={checkIntegrationAccess('category', 'cannotEditChoice')}
            >
              {_.range(0, 21).map(value => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </Select>

            <Select
              as='select'
              custom
              className={classes.select}
              label="Maximum"
              id='max'
              onChange={e => updateCategory(e, this)}
              onBlur={e => {
                checkMinValue(e, this, min);
              }}
              value={max || 'sans limite'}
              required
              name='maximum'
              disabled={checkIntegrationAccess('category', 'cannotEditChoice')}
            >
              <option value={'sans limite'}>
                sans limite
              </option>
              {_.range(1, 21).map(value => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </Select>
            {hasOptionFree && (
              <Select
                as='select'
                custom
                className={classes.itemSelect}
                label="Nombre d’options offertes"
                id='optionFree'
                onChange={e => updateCategory(e, this)}
                value={optionFree}
                required
                name='optionFree'
              >
                <option value={null}>
                  Aucune
                </option>
                {_.range(1, rangeEnd).map(value => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
              </Select>
            )}
          </div>

          {!(min <= 1 && max === 1) &&
            <>
              <p>Choix Multiple ?</p>
              <RadioGroup
                aria-label='gender'
                name='multiple'
                id='multiple'
                value={String(multiple)}
                onChange={e => updateRadioButton(e, this)}
                row
              >
                <FormControlLabel
                  style={{
                    marginBottom: 0
                  }}
                  value='true'
                  control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
                  label='Oui'
                  disabled={checkIntegrationAccess('category', 'cannotEditChoice')
                  }
                />
                <FormControlLabel
                  style={{
                    marginBottom: 0
                  }}
                  value='false'
                  control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
                  label='Non'
                  disabled={checkIntegrationAccess('category', 'cannotEditChoice')}
                />
              </RadioGroup>
            </>}

          {checkAccess('features', 'globalProduct') && (
            <Checkbox
              value={synchronize}
              name='synchronize'
              text="Synchroniser cette liste d'options sur un ou plusieurs magasins"
              onClick={() => this.setState({ synchronize: !synchronize })}
              hidden={_.size(getShopsToSynchronise()) === 1}
            />
          )}
          {showModal && this.renderShops(classes, shopId)}
        </div>
      </Modal>
    );
  }
}

function mapStateToProps({ firebaseRealTime, user }) {
  const { shopId, nbShops } = user;
  const { shop, shops, menu = {} } = firebaseRealTime;
  const { categories = {}, sections = {} } = menu;
  return {
    configurations: shop,
    categories,
    sections,
    shopId,
    shops,
    nbShops
  };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(CategoryModal));
